import React from 'react';
import { Button, Input } from 'reactstrap';
import { MdClose, MdSearch } from 'react-icons/md';

/**
 * Unterhalb dieser Zeilenzahl findet man von Hand schneller als ueber ein Suchfeld. Bewusst
 * niedrig: bei 10 blieb das Feld in typischen Veranstaltungen die ganze Zeit verborgen, und
 * wer es nie sieht, weiss auch nicht, dass er nach einem Namen suchen kann.
 */
export const MINDESTANZAHL_FUER_FILTER = 5;

/**
 * Sucht in EFN und Beschriftung zugleich. Reine Ziffernfolgen werden zusaetzlich als
 * Teilstueck der EFN verstanden - auch mit Leerzeichen dazwischen, weil eine 15-stellige
 * Nummer beim Abtippen fast immer gruppiert wird.
 */
export const passtZumFilter = (filter, efn, beschriftung) => {
	const suche = (filter || '').trim().toLowerCase();
	if(!suche) return true;
	const efnText = String(efn || '');
	const nurZiffern = suche.replace(/\D/g, '');
	if(nurZiffern && nurZiffern === suche.replace(/\s/g, '') && efnText.includes(nurZiffern)) return true;
	const { text = '' } = beschriftung || {};
	return efnText.toLowerCase().includes(suche)
		|| text.toLowerCase().includes(suche);
};

const ListenFilter = (props) => {
	const { wert, onChange, anzahlGesamt, anzahlAngezeigt } = props;
	return (
		<div className="mb-2">
			<div className="input-group input-group-sm" style={{ maxWidth: '24rem' }}>
				<span className="input-group-text"><MdSearch size="1.15em" /></span>
				<Input bsSize="sm" type="text" value={wert} placeholder="EFN, Name oder Notiz suchen"
					onChange={(e) => onChange(e.target.value)} />
				{ wert &&
					<Button color="secondary" outline size="sm" title="Suche zurücksetzen" onClick={() => onChange('')}>
						<MdClose size="1.15em" />
					</Button>
				}
			</div>
			{ wert &&
				<div className="small text-body-secondary mt-1">{anzahlAngezeigt} von {anzahlGesamt} angezeigt</div>
			}
		</div>
	);
};

export default ListenFilter;
